import React from 'react';

import { intercomDirectoryQrRoute as route } from 'routes/constants';

const RouteComponent = React.lazy(() => import('./IntercomDirectoryQrPage'));

export default {
  RouteComponent,
  path: route,
  // name is required for React keys in createRoute.js and WrappedRoute.js (Suspense)
  // even though this page doesn't use Redux/sagas. Using name instead of path ensures
  // stable component reconciliation when paths change.
  name: 'intercomDirectoryQr',
};
